// -- internal
import upmind from "./default";
import type { Theme } from "@upmind-automation/upmind-ui";
// -----------------------------------------------------------------------------
export default [upmind] as Theme[];
